import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";
import { Share2 } from "lucide-react";

export default function ShareStatsPanel({ rallyId }) {
  const [s, setS] = useState(null);
  useEffect(() => { axios.get(`${API}/share/stats/rally/${rallyId}`).then(r => setS(r.data)).catch(() => {}); }, [rallyId]);
  if (!s) return null;
  const ch = Object.entries(s.by_channel || {}).sort((a, b) => b[1] - a[1]);
  return (
    <div className="rl-card p-6" data-testid="share-stats-panel">
      <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-1"><Share2 className="w-5 h-5 text-[#FF9F0A]" /> Social & condivisioni</h2>
      <p className="text-xs text-slate-500 mb-4">Valore digitale generato dai fan per l'evento e per gli sponsor.</p>
      <div className="grid grid-cols-3 gap-3 mb-4">
        {[["CONDIVISIONI", s.shares], ["CLIC RICEVUTI", s.clicks], ["NUOVI UTENTI", s.signups]].map(([l, v]) => <div key={l} className="rl-card p-3 text-center"><div className="font-display font-black text-2xl">{v}</div><div className="text-[10px] font-mono-rl text-slate-500 tracking-widest">{l}</div></div>)}
      </div>
      {ch.length > 0 && <div className="flex flex-wrap gap-2">{ch.map(([k, v]) => <span key={k} className="pill-badge">{k.toUpperCase()} · {v}</span>)}</div>}
      {s.shares === 0 && <div className="text-xs text-slate-500">Nessuna condivisione ancora: usa "CONDIVIDI EVENTO" per lanciare il Paddock sui social.</div>}
    </div>
  );
}
